import dispatcher from '../dispatcher';
import roundButtonStore from './round-button.store';
import popupStore from '../popup/popup.store';
import popupToggleProto from '../popup/popup-toggle.component';
import slideScrollStore from '../slide-scroll/slide-scroll.store';
import firstScrollStore from '../scroll/first-scroll.store';
import colorStore from '../color/color.store';
import TweenMax from 'gsap/all';

var elementProto = Object.create(HTMLButtonElement.prototype);

var _build = function() {
	var w = this._textInnerElement.clientWidth;
	var h = this._textInnerElement.clientHeight;
	var text = this._textInnerElement.innerHTML;
	var letters = text.split('');
	var self = this;

	this._textInnerElement.innerHTML = '';

	letters.forEach(function(letter, index) {
		var sp = document.createElement('span');
		var sh;
		sp.innerHTML = letter;

		self._textInnerElement.appendChild(sp);
		sp.style.transformOrigin = '50% ' + (h / 2) + 'px';
		sp.style.transform = 'rotate(' + index * 25 + 'deg)';
		self._spans.push(sp);
	});
}

var _animateClick = function() {
	var self = this;
	TweenMax.to({y: 0}, 0.2, {
		y: -3,
		ease: Power2.easeInOut,
		onUpdate: function() {
			var y = this._targets[0].y;

			self._spans.forEach(function(sp, index) {
				sp.style.transform = 'rotate(' + index * 25 + 'deg) '
					+ 'translateY(' + y + 'px)';
			});
		},
		onComplete: function() {
			TweenMax.to({y: -3}, 0.2, {
				y: 0,
				ease: Power2.easeInOut,
				onUpdate: function() {
					var y = this._targets[0].y;

					self._spans.forEach(function(sp, index) {
						sp.style.transform = 'rotate(' + index * 25 + 'deg) '
							+ 'translateY(' + y + 'px)';
					});
				}
			});
		}
	});
}

var _handleFirstScroll = function() {
	var scrolled = firstScrollStore.getData().scrolled;
	if (scrolled && this._scrollGrow) {
		this._scrollGrow = false;
		this.check();

	} else if (!scrolled && !this._scrollGrow) {
		this._scrollGrow = true;
		this.check();
	}
}

var _handleSlides = function() {
	var storeData = slideScrollStore.getData().items['report-slides'];
	if (storeData && storeData.index !== 0) {
		this._slideShrink = true;
		this.check();
	} else {
		this._slideShrink = false;
		this.check();
	}
}

var _handleMouseenter = function() {
	this._hoverGrow = true;
	this.check();
}

var _handleMouseleave = function() {
	this._hoverGrow = false;
	this.check();
}

var _handlePopup = function() {
	var active = popupStore.getData().active;
	if (active && ['action-popup', 'map-popup'].indexOf(active) === -1) {
		this._popupShrink = true;
	} else {
		this._popupShrink = false;
	}
	if (['action-popup', 'map-popup'].indexOf(active) !== -1) {
		this._popupGrow = true;
	} else {
		this._popupGrow = false;
	}
	this.check();
}

var _handlButtonStore = function() {
	var shrink = roundButtonStore.getData().shrink;
	var self = this;

	if (shrink) {
		this._shrink = true;
		this.classList.add('shrink');
	} else {
		this._shrink = false;
		this.classList.remove('shrink');
	}
}

var _check = function() {
	if ((this._scrollGrow && !this._popupShrink && !this._slideShrink) ||
		this._hoverGrow || this._popupGrow) {
		dispatcher.dispatch({
			type: 'round-button:grow'
		});
	} else {
		dispatcher.dispatch({
			type: 'round-button:shrink'
		});
	}
}

var _loop = function() {
	var gradient;
	var colorString;

	if (this._destruct) return;
	gradient = colorStore.getData().mixGradient;

	colorString = 'linear-gradient(to top left, '
		+ 'rgb(' + Math.floor(gradient[0].x * 255)
		+ ', ' + Math.floor(gradient[0].y * 255)
		+ ', '  + Math.floor(gradient[0].z * 255) + '), '
		+ 'rgb(' + Math.floor(gradient[1].x * 255)
		+ ', ' + Math.floor(gradient[1].y * 255)
		+ ', '  + Math.floor(gradient[1].z * 255) + '))';

	if (this._currentColor !== colorString) {
		this._currentColor = colorString;

		this._bg.style.backgroundImage = colorString;
	}

	requestAnimationFrame(this.loop);
}

elementProto.createdCallback = function() {
	popupToggleProto.createdCallback.apply(this);

	this.build = _build.bind(this);
	this.check = _check.bind(this);
	this.handleButtonStore = _handlButtonStore.bind(this);
	this.handleFirstScroll = _handleFirstScroll.bind(this);
	this.handleMouseenter = _handleMouseenter.bind(this);
	this.handleMouseleave = _handleMouseleave.bind(this);
	this.handleSlides = _handleSlides.bind(this);
	this.handlePopup = _handlePopup.bind(this);
	this.animateClick = _animateClick.bind(this);
	this.loop = _loop.bind(this);

	this._spans = [];

	this._scrollGrow = true;
	this._hoverGrow = false;
	this._popupShrink = false;
	this._popupGrow = false;
	this._slideShrink = false;
	this._shrink = false;

	this._currentColor = null;

}
elementProto.attachedCallback = function() {
	popupToggleProto.attachedCallback.apply(this);

	this._textInnerElement = this.getElementsByClassName('text-inner')[0];
	this._textInnerElement.style.display = 'block';
	this._bg = this.getElementsByClassName('bg')[0];

	this.build();

	roundButtonStore.subscribe(this.handleButtonStore);
	firstScrollStore.subscribe(this.handleFirstScroll);
	slideScrollStore.subscribe(this.handleSlides);
	popupStore.subscribe(this.handlePopup);

	this.handleFirstScroll();
	this.handlePopup();
	this.handleSlides();

	this.addEventListener('mouseenter', this.handleMouseenter);
	this.addEventListener('mouseleave', this.handleMouseleave);
	this.addEventListener('click', this.animateClick);

	this.loop();
}
elementProto.detachedCallback = function() {
	this._destruct = true;
	popupToggleProto.detachedCallback.apply(this);

	roundButtonStore.unsubscribe(this.handleButtonStore);
	firstScrollStore.unsubscribe(this.handleFirstScroll);
	slideScrollStore.unsubscribe(this.handleSlides);
	popupStore.unsubscribe(this.handlePopup);
}

document.registerElement('round-button', {
	prototype: elementProto,
	extends: 'button'
});